<template>
  <svg viewBox="0 0 80 94" xmlns="http://www.w3.org/2000/svg">
    <title>Klimate Logo</title>
    <path d="M19.9798 88.9028H0V4.83984H19.9798V88.9028Z" />
    <path
      d="M54.9251 88.9085L28.1467 53.6855C25.0865 49.6597 25.0865 44.0886 28.1467 40.0628L54.9251 4.83984H79.1562L50.3091 41.3971C47.7732 44.6075 47.7732 49.1408 50.3091 52.3512L79.1562 88.9085H54.9251Z"
    />
  </svg>
</template>
